module.exports = __webpack_public_path__ + "static/media/5.5471b925.jpg";